var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ApolloClient, ApolloLink, } from '@apollo/client';
import createCache from './cache.js';
export const createClient = (_a) => {
    var { links = [], httpLink, cacheOptions, cache, ssrMode = false, enableDevTools = true } = _a, restOptions = __rest(_a, ["links", "httpLink", "cacheOptions", "cache", "ssrMode", "enableDevTools"]);
    return new ApolloClient({
        devtools: {
            enabled: enableDevTools,
        },
        link: ApolloLink.from([...links, httpLink(restOptions)]),
        cache: cache !== null && cache !== void 0 ? cache : createCache(cacheOptions),
        ssrMode,
    });
};
//# sourceMappingURL=client.js.map